import React from 'react';

import classNames from 'classnames';

import { getThemeClassNames } from '@cognite/cogs-utils-v11/helpers/get-theme-class-names/get-theme-class-names.ts';

import type { ProductLogoSvgProps } from '../types';

export const CDF: React.FC<React.PropsWithChildren<ProductLogoSvgProps>> = ({
  size = '40',
  inverted,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(
      'cogs-v11',
      'cogs-cognite-logo',
      'cogs-graphic',
      'cogs-graphic--cdf',
      ...getThemeClassNames(inverted)
    )}
  >
    <title>CDF product logo</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.813 17.8489V15.9578C30.813 15.0441 30.0723 14.3034 29.1586 14.3034C28.2449 14.3034 27.5042 15.0441 27.5042 15.9578V18.3678C26.5509 18.5868 25.4495 18.8066 24.3474 19.0264V10.4746C24.3276 9.56912 23.5788 8.85034 22.6733 8.86749H22.6654C21.777 8.87045 21.0556 9.58625 21.0457 10.4746V19.8299C20.9428 19.8265 20.841 19.8518 20.7518 19.9032C19.7395 20.1197 18.7927 20.3361 17.8459 20.5526L17.8125 20.5602V13.3265C17.7852 12.4542 17.0702 11.7612 16.1974 11.7612C15.3247 11.7612 14.6097 12.4542 14.5824 13.3265V21.2874C14.2735 21.3454 13.9744 21.4033 13.6828 21.4597L13.6828 21.4597C12.8657 21.6178 12.1071 21.7645 11.3524 21.872V18.1464C11.3142 17.2821 10.6024 16.6011 9.73736 16.6011C8.87228 16.6011 8.16052 17.2821 8.12234 18.1464V22.3108C4.45112 22.7496 2.32323 22.6038 2.10106 21.9436C1.64794 20.9741 4.23149 19.6619 5.49752 19.019L5.49763 19.0189C5.66451 18.9341 5.80849 18.861 5.9196 18.8018V18.7294H5.84634C4.89229 19.0941 0.779897 20.7777 1.29434 22.2351C1.80721 23.8439 8.12234 24.2835 21.267 21.0668C32.2783 18.363 37.3448 17.8486 37.8592 18.8727C38.2263 19.7488 35.5084 21.43 32.866 22.5991C32.8094 22.6567 32.7824 22.7372 32.7928 22.8173L32.7939 22.8185C32.8668 22.8914 32.9389 22.9635 33.0134 22.8906C33.9666 22.5235 38.9606 20.4074 38.7392 18.6529C38.5202 17.4849 35.8774 17.1192 30.813 17.8489ZM8.13809 26.7706V25.5463C9.20986 25.4849 10.2774 25.3642 11.3358 25.1847V26.7706C11.3165 27.6398 10.6064 28.3344 9.73696 28.3344C8.86754 28.3344 8.15739 27.6398 8.13809 26.7706ZM14.5927 24.6419V29.0962C14.585 29.9728 15.2843 30.6922 16.1607 30.7092C17.0372 30.7263 17.764 30.0346 17.7904 29.1585V23.9841C16.7385 24.2666 15.6707 24.4862 14.5927 24.6419ZM27.3297 21.8953V21.8971L27.3266 21.8976L27.3297 21.8953ZM27.3297 21.8971C28.5826 21.6788 29.6877 21.4613 30.6448 21.2445V23.786C30.6302 24.6705 29.9104 25.3805 29.0259 25.3829H29.0164C28.5809 25.395 28.1585 25.2335 27.8422 24.934C27.5258 24.6345 27.3415 24.2215 27.3297 23.786V21.8971ZM21.0957 23.3512H20.8751V26.4812C20.9139 27.3689 21.6449 28.0688 22.5335 28.0688C23.4221 28.0688 24.1531 27.3689 24.1918 26.4812V22.6209C23.9646 22.6728 23.7333 22.7247 23.4978 22.7775C22.7404 22.9472 21.9401 23.1266 21.0957 23.3496V23.3512Z"
      fill="inherit"
      fillOpacity="0.9"
    />
  </svg>
);
